export const ThemeSelectorClasses =
{
    Modal: "themeSelector__modal",
    Container: "themeSelector__container",
    Item: "themeSelector__item",
    ItemSelected: "themeSelector__item--selected",
    ItemHeader: "themeSelector__itemHeader",
    ItemHeaderSvg: "themeSelector__itemHeaderSvg",
    ItemDivider: "themeSelector__itemDivider",
    ColorContainer: "themeSelector__colorContainer",
    Color: "themeSelector__color",
    Color1: "themeSelector__color1",
    Color2: "themeSelector__color2",
    Color3: "themeSelector__color3",
    Color4: "themeSelector__color4",
    ItemFooter: "themeSelector__itemFooter",
    RadioButton: "themeSelector__radioButton",
    TempCSS: "tempCss",
    ThemeStyleSheet: "themeStyleSheet"
};
Object.freeze(ThemeSelectorClasses);

export const ThemeSelectorDataKeys =
{
    ThemeID: "themeId",
    CSSHash: "cssHash",
};
Object.freeze(ThemeSelectorDataKeys);